// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBmNFHPqabmqZFVFzYKPYXjxDqkjBI9yNw",
  authDomain: "eat-everything-81f19.firebaseapp.com",
  projectId: "eat-everything-81f19",
  storageBucket: "eat-everything-81f19.firebasestorage.app",
  messagingSenderId: "549670216395",
  appId: "1:549670216395:web:fda53785b25c48a148b14e",
  measurementId: "G-HSRRMFT0VT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, auth, analytics, db };